import React, {useState} from "react";
import { useRentalData } from "../../hooks/useRentalData";
import Form from "./Form";
import {getDataFresh, getDepartmentsData, getKeysData} from "../../state/selectors";
import { useSelector } from "react-redux";
import {useDefaultsData} from "../../hooks/useDefaultsData";
import {useKeysData} from "../../hooks/useKeysData";
import {useRentalMarginData} from "../../hooks/useRentalMarginData";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import {useRateCardsData} from "../../hooks/useRateCardsData";
import {useUtilData} from "../../hooks/useUtilData";

function RentalForm(props) {
  let dataFresh = useSelector(getDataFresh);
  let app_defaults_loaded = useDefaultsData({});
  let [utilsParam, setUtilsParam] = useState({
      department: 1,
      key: 1,
      margin: 1,
      tracking: 1,
      movement_rate: 1,
      movement_type: 1,
      driver: 1,
      nominal: 1
  })
  //let rateCardsLoaded = useRateCardsData({page_size: 1000}); // This doesnt need dataFresh, it wont be updated often
  let rental_loaded = useRentalData(props.match.params.rental, dataFresh);
  //let margins_loaded = useRentalMarginData({}, dataFresh)
  //let keys_loaded = useKeysData({});
  //let departmentsLoaded = useDepartmentsData({}, dataFresh);
  //let trackingOptionsLoaded = useTrackingOptionsData({}, dataFresh);
  let utilsLoaded = useUtilData(utilsParam);
  return (
    <Form
      loaded={rental_loaded && utilsLoaded} //keys_loaded && margins_loaded && departmentsLoaded && trackingOptionsLoaded && rateCardsLoaded
      endpoint={props.endpoint}
      location={props.location}
      history={props.history}
      utilsParam={utilsParam}
      setUtilsParam={setUtilsParam}
    />
  );
}

export default RentalForm;
